import { getFeedDepartmentsPath, getFeedInterestPath, getFeedLocationPath, getProfilePath, getFeedSkillsPath } from "app/links";
import { getFeedCompaniesPath } from "app/links/CompanyLink";

const getMentionLink = ({ type, entityId, userId }, landingPage) => {
  switch (type) {
    case "departments":
      return getFeedDepartmentsPath({ id: entityId });
    case "interests":
      return getFeedInterestPath({ id: entityId });
    case "locations":
      return getFeedLocationPath({ id: entityId });
    case "skills":
      return getFeedSkillsPath({ id: entityId });
    case "companies":
      return getFeedCompaniesPath({ id: entityId });
    case "organizations":
      return "/";
    default:
      return getProfilePath({ id: userId }, landingPage);
  }
};

export default getMentionLink;
